import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Plugins } from '@capacitor/core';
import { Platform } from '@ionic/angular';

import { Camera } from '@capacitor/camera';
import { Filesystem } from '@capacitor/filesystem';
import { Geolocation } from '@capacitor/geolocation';

const { Permissions } = Plugins;


type PermissionHandler = {
  check: () => Promise<any>;
  request: () => Promise<any>;
  key: string; // key in the returned object for the permission status
};

// 'android.permission.CAMERA',
// 'android.permission.READ_MEDIA_IMAGES',
// 'android.permission.READ_MEDIA_VIDEO',
// 'android.permission.ACCESS_FINE_LOCATION',
// 'android.permission.ACCESS_COARSE_LOCATION'
const permissionMapping: { [key: string]: PermissionHandler } = {
  // Use your own keys or Android permission strings as keys
  'android.permission.CAMERA': {
    check: Camera.checkPermissions,
    request: Camera.requestPermissions,
    key: 'android.permission.CAMERA'
  },
  'android.permission.ACCESS_FINE_LOCATION': {
    check: Geolocation.checkPermissions,
    request: Geolocation.requestPermissions,
    key: 'android.permission.ACCESS_FINE_LOCATION'
  },
  'android.permission.ACCESS_COARSE_LOCATION': {
    check: Geolocation.checkPermissions,
    request: Geolocation.requestPermissions,
    key: 'android.permission.ACCESS_COARSE_LOCATION'
  },
  // Add additional mappings for media permissions if you use a Filesystem or similar plugin
};


@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor(private platform: Platform) {}

  async checkAndRequestPermission(permission: string): Promise<boolean> {
    // Only handle Android (or you could add web logic here)
    if (!this.platform.is('android')) {
      return true;
    }
  
    const handler = permissionMapping[permission];
    if (!handler) {
      console.error(`No handler for permission: ${permission}`);
      return false;
    }
  
    try {
      // Check the current permission status
      const status = await handler.check();
      if (status[handler.key] === 'granted') {
        return true;
      }
  
      // Request the permission if not granted
      const result = await handler.request();
      return result[handler.key] === 'granted';
    } catch (error) {
      console.error('Permission error:', error);
      return false;
    }
  }
  
  async checkMultiplePermissions(permissions: string[]): Promise<Map<string, boolean>> {
    const results = new Map<string, boolean>();
  
    for (const permission of permissions) {
      results.set(permission, await this.checkAndRequestPermission(permission));
    }
  
    return results;
  }

  
  // async checkAndRequestPermission(permission: string): Promise<boolean> {
  //   if (!this.platform.is('android')) {
  //     return true;
  //   }

  //   try {
  //     const permissionStatus = await Permissions['checkPermission'](permission);
      
  //     if (permissionStatus.granted) {
  //       return true;
  //     }

  //     const requestResult = await Permissions['requestPermission'](permission);
  //     return requestResult.granted;
  //   } catch (error) {
  //     console.error('Permission error:', error);
  //     return false;
  //   }
  // }

  // async checkMultiplePermissions(permissions: string[]): Promise<Map<string, boolean>> {
  //   const results = new Map<string, boolean>();
    
  //   for (const permission of permissions) {
  //     results.set(permission, await this.checkAndRequestPermission(permission));
  //   }
    
  //   return results;
  // }

// async checkCameraPermissionRequest() {
//   const checkCameraPermission = async () => {
//     const permission = await Camera.checkPermissions();
  
//     if (permission.camera !== 'granted') {
//       const request = await Camera.requestPermissions();
//       if (request.camera !== 'granted') {
//         console.error('Camera permission denied');
//       }
//     }
//   };
// }

// async checkMediaPermissionRequest() {

//   const checkMediaPermission = async () => {
//     const permission = await Filesystem.checkPermissions();
  
//     if (permission.publicStorage !== 'granted') {
//       const request = await Filesystem.requestPermissions();
//       if (request.publicStorage !== 'granted') {
//         console.error('Media permission denied');
//       }
//     }
//   };
// }

// async checkLocationPermissionRequest() {


//   const checkLocationPermission = async () => {
//     const permission = await Geolocation.checkPermissions();
  
//     if (permission.location !== 'granted') {
//       const request = await Geolocation.requestPermissions();
//       if (request.location !== 'granted') {
//         console.error('Location permission denied');
//       }
//     }
//   };
// }





}